import { useCallback } from 'react';
import { invariant } from 'ts-invariant';
import type { OnActionType } from '../../../../context/ActionsProvider/context';
import { SHOULD_NOT_PROPAGATE_UP } from '../../const';
import useControlBlockMethod from '../controlBlockMethod/useControlBlockMethod';

type DrawerActionPayload = {
  drawerId?: string;
  operation: 'show' | 'hide';
};

function useControlDrawerActions() {
  const { onCallBlockMethod } = useControlBlockMethod();

  const onControlDrawer: OnActionType = useCallback(
    async ({ action, actionContext, instanceId }) => {
      const payload = action.payload as DrawerActionPayload;
      const blockId = payload.drawerId;
      invariant(blockId, 'Drawer id is required');

      switch (payload.operation) {
        case 'show':
          await onCallBlockMethod({
            blockId,
            methodName: 'showDrawer',
            action,
            actionContext,
            instanceId,
          });
          break;
        case 'hide':
          await onCallBlockMethod({
            blockId,
            methodName: 'hideDrawer',
            action,
            actionContext,
            instanceId,
          });
          break;
        default:
          break;
      }
      return Promise.resolve(SHOULD_NOT_PROPAGATE_UP);
    },
    [onCallBlockMethod],
  );

  return { onControlDrawer };
}

export default useControlDrawerActions;
